import { render, staticRenderFns } from "./BlueBackgroundDetail.vue?vue&type=template&id=6eba4f4d&scoped=true"
import script from "./BlueBackgroundDetail.vue?vue&type=script&lang=js"
export * from "./BlueBackgroundDetail.vue?vue&type=script&lang=js"
import style0 from "./BlueBackgroundDetail.vue?vue&type=style&index=0&id=6eba4f4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eba4f4d",
  null
  
)

export default component.exports